export type PickupLocationType = {
  name: string;
  address: string;
  query: {
    placeId: string;
    geoLocation: { lat: number; lng: number };
  };
} | null;

export enum PickupAnswer {
  IDK = "idk",
  DEFAULT_MEETING_PLACE = "defaultMeetingPlace",
  IKNOW = "iknow",
}

export type GeoLocation = {
  lat: number;
  lng: number;
};

export type GoogleMapsQuery = {
  __typename?: "GoogleMapsQuery";
  geoLocation?: GeoLocation | null;
  placeId?: string | null;
};
